var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"card tw-shadow tw-bg-white"},[_c('card-top',{attrs:{"icon":_vm.icon,"text":_vm.title}},[_vm._t("card-top")],2),_c('div',{staticClass:"card-inner tw-p-6"},[_vm._t("default")],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }